// 'use client';

// import { ITrandingStore } from '@/lib/types/cms';
// import {
//   motion,
//   useMotionValue,
//   useScroll,
//   useVelocity,
//   useSpring,
//   useTransform,
//   useAnimationFrame,
// } from 'framer-motion';
// import TrendingStoresCard from './TrendingStoresCard';
// import useMeasure from 'react-use-measure';
// import { useMemo, useRef } from 'react';
// import { wrap } from '@motionone/utils';
// import ParallaxCard from './ParallaxCard';

// type Props = {
//   section: string;
//   description: string;
//   duration?: number;
// };

// const TrendingStoresSection = ({ section, description, duration = 5 }: Props) => {
//   const [ref, { width }] = useMeasure();
//   const isMobile = width < 640;
//   const isMd = width >= 640 && width < 1024;
//   const isLarge = width >= 1024;

//   const cardSize = useMemo(() => {
//     const isMobile = width < 640;
//     const isMd = width >= 640 && width < 1024;
//     const isLarge = width >= 1024;

//     const logosToDisplay = isLarge ? 8 : isMd ? 6 : 4;
//     return width ? Math.min(width / logosToDisplay, 150) : 100;
//   }, [width]);

//   // const xTranslation = useMotionValue(0);
//   // const { scrollY } = useScroll();
//   // const scrollVelocity = useVelocity(scrollY);
//   // const smoothVelocity = useSpring(scrollVelocity, {
//   //   damping: 50,
//   //   stiffness: 400,
//   // });
//   // const velocityFactor = useTransform(smoothVelocity, [0, 1024], [0, 8], { clamp: false });

//   // const stores = JSON.parse(section) as ITrandingStore[];
//   // const minLogosNeeded = 8;

//   // const duplicatedLogos = useMemo(() => {
//   //   return stores.length < minLogosNeeded
//   //     ? Array(Math.ceil(minLogosNeeded / stores.length))
//   //         .fill(stores)
//   //         .flat()
//   //     : stores;
//   // }, [stores]);

//   // const repeatedLogos = useMemo(() => [...duplicatedLogos, ...duplicatedLogos], [duplicatedLogos]);

//   // const directionFactor = useRef<number>(1);

//   // const x = useTransform(xTranslation, (v) => `${wrap(-width / 2 - 14, 0, v)}px`);

//   // useAnimationFrame((t, delta) => {
//   //   let moveBy = directionFactor.current * 50 * (delta / 1000);

//   //   if (velocityFactor.get() < 0) {
//   //     directionFactor.current = -1;
//   //   } else if (velocityFactor.get() > 0) {
//   //     directionFactor.current = 1;
//   //   }

//   //   moveBy += directionFactor.current * moveBy * velocityFactor.get();

//   //   xTranslation.set(xTranslation.get() + moveBy);
//   // });

//   // console.log(JSON.parse(section).length, isLarge, isMobile);

//   if ((isMobile && JSON.parse(section).length > 3) || (isLarge && JSON.parse(section).length > 7))
//     return (
//       <div className="flex h-full w-full flex-col gap-1 rounded-xl bg-black py-5">
//         <p className="mb-6 text-2xl font-bold text-white">{description}</p>

//         <div className="flex flex-col gap-2 overflow-hidden py-2 lg:gap-4 lg:py-4" ref={ref}>
//           <ParallaxCard baseVelocity={100}>
//             {JSON.parse(section)?.map((store: ITrandingStore, index: number) => (
//               <TrendingStoresCard key={index} store={store} size={cardSize} />
//             ))}
//           </ParallaxCard>
//         </div>
//       </div>
//     );

//   return null;
// };

// export default TrendingStoresSection;

// ///////////////////////

'use client';

import { ITrandingStore } from '@/types/cms';
import TrendingStoresCard from './TrendingStoresCard';
import useMeasure from 'react-use-measure';
import { useMemo } from 'react';
import ParallaxCard from './ParallaxCard';

type Props = {
  section: string;
  description: string;
  duration?: number;
};

const TrendingStoresSection = ({ section, description }: Props) => {
  const [ref, { width }] = useMeasure();

  // Memoize the parsed section to avoid re-parsing on each render
  const parsedSection = useMemo(() => {
    try {
      return JSON.parse(section) as ITrandingStore[];
    } catch (error) {
      console.error('Invalid JSON in section:', error);
      return [];
    }
  }, [section]); // Depend on `section` string

  const isMobile = width < 640;
  const isLarge = width >= 1024;

  // Memoize card size calculation
  const cardSize = useMemo(() => {
    const logosToDisplay = isLarge ? 8 : isMobile ? 4 : 6; // Default for medium screens
    return width ? Math.min(width / logosToDisplay, 150) : 100;
  }, [width, isMobile, isLarge]);

  // Conditional rendering based on screen size and section length
  // if (
  //   (isMobile && parsedSection.length >= 4) ||
  //   (isLarge && parsedSection.length > 7) ||
  //   (isMd && parsedSection.length > 6)
  // ) {
  return (
    <div className="flex h-full w-full flex-col gap-1 rounded-xl bg-black py-5" dir="ltr">
      <p className="mb-6 text-2xl font-bold text-white">{description}</p>

      <div className="flex flex-col gap-2 overflow-hidden py-2 lg:gap-4 lg:py-4" ref={ref}>
        <ParallaxCard baseVelocity={-40}>
          {parsedSection.map((store: ITrandingStore, index: number) => (
            <TrendingStoresCard key={index} store={store} size={cardSize} />
          ))}
        </ParallaxCard>
      </div>
    </div>
  );
};

export default TrendingStoresSection;
